import React, { SVGProps } from 'react';

export const EyeIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 25,
  height = 17,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 25 17"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 0C6.81818 0 1.96591 3.52467 0 8.5C1.96591 13.4753 6.81818 17 12.5 17C18.1875 17 23.0341 13.4753 25 8.5C23.0341 3.52467 18.1875 0 12.5 0ZM12.5 14.1667C9.36364 14.1667 6.81818 11.628 6.81818 8.5C6.81818 5.372 9.36364 2.83333 12.5 2.83333C15.6364 2.83333 18.1818 5.372 18.1818 8.5C18.1818 11.628 15.6364 14.1667 12.5 14.1667ZM12.5 5.1C10.6193 5.1 9.09091 6.62433 9.09091 8.5C9.09091 10.3757 10.6193 11.9 12.5 11.9C14.3807 11.9 15.9091 10.3757 15.9091 8.5C15.9091 6.62433 14.3807 5.1 12.5 5.1Z"
        fill="white"
      />
    </svg>
  );
};
